import { Icon, IconArrowBigDown, IconArrowBigUp, IconExpand } from "@flixbus/honeycomb-icons-react";
import * as React from "react";
import { SortDirection, SortField } from "../../../../shared/types/schema";
import useRideSort, { rideSortVar } from "../../../../state/useRideSort/useRideSort";
import * as css from "./SortableColumn.scss";

export type SortIconProps = {
  field: SortField;
};

const SortableColumn: React.FC<SortIconProps> = ({ field, children }) => {
  const [rideSort, setRideSort] = useRideSort(rideSortVar);

  const renderIcon = () => {
    if (field !== rideSort.field) {
      return IconExpand;
    }

    return rideSort.direction === SortDirection.Asc ? IconArrowBigUp : IconArrowBigDown;
  };

  const handleOnClick = () => {
    const getNewDirection = (otherField: SortField) => {
      if (rideSort.field === otherField) {
        return SortDirection.Asc;
      }

      return rideSort.direction === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
    };

    if (field === SortField.Departure) {
      setRideSort({
        field: SortField.Departure,
        direction: getNewDirection(SortField.NumberOfPax),
      });
    } else {
      setRideSort({
        field:
          rideSort.field === SortField.NumberOfPax && rideSort.direction === SortDirection.Desc
            ? SortField.Departure
            : SortField.NumberOfPax,
        direction: getNewDirection(SortField.Departure),
      });
    }
  };

  return (
    <div onClick={handleOnClick} className={css.container}>
      {children}
      <div className={css.iconContainer}>
        <Icon InlineIcon={renderIcon()} />
      </div>
    </div>
  );
};

export default SortableColumn;
